import { call, put, takeEvery } from "redux-saga/effects";
import { monTuongDuongApi } from "../../../api/category/monTuongDuongApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eMonTuongDuongActionIds, IMonTuongDuongActionTypes } from "../../action-types/category/IMonTuongDuongActions";
import { rootActions } from "../../actions/rootActions";
import { IMonTuongDuong } from './../../../model/respone/category/IMonTuongDuong';
import { IIdsRequest } from "../../../model/request/IIdsRequest";
const mainAction = rootActions.category.monTuongDuong;
export function* monTuongDuongSaga(): any {
  yield takeEvery(eMonTuongDuongActionIds.LOAD_START, loadWorker);
  yield takeEvery(eMonTuongDuongActionIds.SAVE_START, saveWorker);
  yield takeEvery(eMonTuongDuongActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(monTuongDuongApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IMonTuongDuongActionTypes): any {
  let res: IBaseRespone;//= yield call(monTuongDuongApi.SelectAll);
  const payload = action.payload as IMonTuongDuong;
  if (payload.id_tuong_duong > 0) {
    res = yield call(monTuongDuongApi.Update, payload);
  } else {
    res = yield call(monTuongDuongApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IMonTuongDuongActionTypes): any {
  const res: IBaseRespone = yield call(monTuongDuongApi.Deletes, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}